import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import DailyReportService from "../services/DailyReportService";
import ProjectService from "../services/ProjectService";
import Breadcrumb from "../components/Breadcrumb";
import StorageService from "../services/StorageService";
import UomService from "../services/UomService";
import VendorService from "../services/VendorServices";
import VendorCategoryService from "../services/VendorCategoryService";
import WorkItemService from "../services/workitemService";
import LocationService from "../services/LocationService";
import MessageDialog from "../components/MessageDialog";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import 'react-tabs/style/react-tabs.css';
import StockOutService from "../services/StockOutService";
import ProjectLocationService from "../services/ProjectLocationService";
import utility from "../utils/utility";



export default function AddDailyReport() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("error");
  const [editMode, setEditMode] = useState(false);
  const [reportId, setReportId] = useState(null);
  const [projects, setProjects] = useState([]);
  const { id } = useParams();
  const [editLoading, setEditLoading] = useState(false);
  const [selectedProjectCategoryCode, setSelectedProjectCategoryCode] = useState("");
  const [showMeasurementFields, setShowMeasurementFields] = useState(false);
  const [stockOutVouchers, setStockOutVouchers] = useState([]);
  const [projectItems, setProjectItems] = useState([]);
  const [reportStatus, setReportStatus] = useState("");
  const [messageDuration, setMessageDuration] = useState(10000);
  const [messageOnClose, setMessageOnClose] = useState(null);

  // const isCivil =
  //   selectedProjectCategoryCode === "Civil Works";

  // const isElectrical =
  //   selectedProjectCategoryCode?.toLowerCase().includes("electrical");

  // const isWater =
  //   selectedProjectCategoryCode?.toLowerCase().includes("water");

  const isCivil =
    selectedProjectCategoryCode?.trim() === "Civil Works";

  const showChainage = !isCivil;

  // Table-based Points
  // const [points, setPoints] = useState([{ point: "" }]);
  const [points, setPoints] = useState([
    {
      point: "",
      workActivity: "",
      workActivities: [],
      workItemId: "",
      locationId: "",
      UOM: "",
      nos: "",
      quantity: "",
      workQuantity: "",
      fromChainage: "",
      toChainage: "",
      side: "",
      remarks: "",
      length: "",
      breadth: "",
      depth: ""
    }
  ]);

  const [materials, setMaterials] = useState([
    {
      itemId: "",
      stockOutVoucherNo: "",
      vouchers: [],
      availableBalance: "",
      quantityUsed: "",
      quantityLost: "",
      quantityDamaged: "",
      quantityReturned: "",
      balance: "",
      notes: ""
    }
  ]);

  const [labours, setLabours] = useState([
    {
      vendorId: "",
      skilledLabour: "",
      unSkilledLabour: "",
      notes: ""
    }
  ]);

  // NEW STATE FOR PREVIOUS REPORT TABLE
  const [prevReports, setPrevReports] = useState([]);

  const [uoms, setUoms] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [vendorCategories, setVendorCategories] = useState([]);
  const [workItems, setWorkItems] = useState([]);
  const [locations, setLocations] = useState([]);

  // const messageTimer = useRef(null);

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    getValues,
    watch,
    formState: { errors }
  } = useForm({
    defaultValues: {
      workStatus: "WORKING",
      idleNote: ""
    }
  });

  const selectedLocationId = watch("locationId");
  const workStatus = watch("workStatus");

  const performChainageValidation = (updatedPoints, idx) => {
    const row = updatedPoints[idx];
    if (isCivil) {
      row.fromChainageError = null;
      row.toChainageError = null;
      return;
    }

    const locId = row.locationId || getValues("locationId");
    if (!locId) {
      row.fromChainageError = null;
      row.toChainageError = null;
      return;
    }

    const loc = locations.find(l => String(l.locationId) === String(locId));
    if (!loc) {
      row.fromChainageError = null;
      row.toChainageError = null;
      return;
    }

    const locFrom = Number(loc.fromKMS);
    const locTo = Number(loc.toKMS);

    // Validate fromChainage
    if (row.fromChainage === "" || row.fromChainage === undefined || row.fromChainage === null) {
      row.fromChainageError = "From Chainage is required";
    } else {
      const fromVal = Number(row.fromChainage);
      if (fromVal < 0) {
        row.fromChainageError = "Cannot be negative";
      } else if (fromVal < locFrom || fromVal > locTo) {
        row.fromChainageError = `Must be between ${locFrom} and ${locTo}`;
      } else {
        row.fromChainageError = null;
      }
    }

    // Validate toChainage
    if (row.toChainage === "" || row.toChainage === undefined || row.toChainage === null) {
      row.toChainageError = "To Chainage is required";
    } else {
      const toVal = Number(row.toChainage);
      if (toVal < 0) {
        row.toChainageError = "Cannot be negative";
      } else if (toVal < locFrom || toVal > locTo) {
        row.toChainageError = `Must be between ${locFrom} and ${locTo}`;
      } else {
        row.toChainageError = null;
      }
    }

    // Validate cross-relationship if both are otherwise valid
    if (!row.fromChainageError && !row.toChainageError) {
      const fromVal = Number(row.fromChainage);
      const toVal = Number(row.toChainage);
      if (fromVal > toVal) {
        row.fromChainageError = "Cannot exceed To Chainage";
        row.toChainageError = "Cannot be less than From Chainage";
      }
    }
  };


  const emp = StorageService.loginData();
  const isPrivilegedDateUser =
    Number(emp?.roleId) === 1 || Number(emp?.roleId) === 2;

  const getTodayDate = () => {
    return new Date().toISOString().split("T")[0];
  };

  useEffect(() => {
    loadProjects();

    if (id) {
      loadReportForEdit(id); // edit mode → keep existing date
    } else {
      // add mode → auto fill today
      setValue("reportDate", getTodayDate());
    }
  }, [id]);

  // LOAD PREVIOUS REPORT TABLE
  const loadPreviousReports = async (projectId) => {
    if (!projectId) {
      setPrevReports([]);
      return;
    }

    try {
      const res = await DailyReportService.getByProject(projectId);

      // if (res?.status && Array.isArray(res.data)) {
      if (res?.data?.status && Array.isArray(res.data.data)) {
        setPrevReports(res.data); // STORE TABLE DATA
      } else {
        setPrevReports([]);
      }
    } catch (err) {
      console.error("Error loading previous reports:", err);
      setPrevReports([]);
    }
  };

  // EDIT MODE LOAD
  const loadReportForEdit = async (reportId) => {
    try {
      setEditLoading(true); // 🔄 START LOADING

      const response = await DailyReportService.getById(reportId);
      const res = response?.data || response;
      console.log(
        "EDIT RESPONSE =",
        JSON.stringify(res, null, 2)
      ); if (!res) return;

      setEditMode(true);
      setReportId(res.id);
      setReportStatus(
        res.status
      );

      // const extracted = res.description
      //   ?.split("\n")
      //   .map(line => line.replace(/^\d+\.\s*/, "").trim())
      //   .filter(Boolean);


      // ✅ STEP 1: LOAD WORK ITEMS FIRST
      // await loadProjectWorkItems(res.projectId || res.projectid);
      const loadedWorkItems =
        await loadProjectWorkItems(
          res.projectId || res.projectid
        );
      await loadProjectLocations(
        res.projectId || res.projectid
      );
      await loadProjectStockOutItems(
        res.projectId || res.projectid,
        res.locationId
      );

      // ✅ STEP 2: FIX DATA EXTRACTION
      const extracted = res.items || [res];

      // ✅ STEP 3: SET TABLE DATA
      // setPoints(
      //   extracted.map(item => ({
      //     point: item.description || "",
      //     workItemId: Number(item.workItemId) || "",

      //     workActivity: item.workActivity || "",


      //     fromChainage: item.fromChainage || "",
      //     toChainage: item.toChainage || "",
      //     side: item.side || "",
      //     remarks: item.remarks || "",
      //     // workQuantity: item.workQuantity || item.quantity || "",
      //     locationId: item.locationId || "",

      //     UOM: item.UOM || "",
      //     quantity: item.projectQuantity || "",
      //     workQuantity: item.workQuantity || "",
      //     // quantity: item.quantity || "",
      //     length: item.length || "",
      //     breadth: item.breadth || "",
      //     depth: item.depth || ""
      //   }))
      // );
      // setPoints(
      //   extracted.map(item => {

      //     const selectedWorkItem =
      //       loadedWorkItems.find(
      //         w =>
      //           Number(w.workItemId) ===
      //           Number(item.workItemId)
      //       );

      //     return {
      //       // point: item.description || "",

      //       workItemId:
      //         Number(item.workItemId) || "",

      //       workActivity:
      //         item.workActivity || "",

      //       workActivities:
      //         selectedWorkItem?.workActivities || [],

      //       fromChainage:
      //         item.fromChainage || "",

      //       toChainage:
      //         item.toChainage || "",

      //       side:
      //         item.side || "",

      //       remarks:
      //         item.remarks || "",

      //       locationId:
      //         item.locationId || "",

      //       UOM:
      //         item.UOM || "",

      //       quantity:
      //         item.projectQuantity ||
      //         item.quantity ||
      //         "",

      //       workQuantity:
      //         item.quantity || "",

      //       length:
      //         item.length || "",

      //       breadth:
      //         item.breadth || "",

      //       depth:
      //         item.depth || ""
      //     };

      //   })
      // );
      const pointData =
        extracted.map(item => {

          const selectedWorkItem =
            loadedWorkItems.find(
              w =>
                Number(w.workItemId) ===
                Number(item.workItemId)
            );

          return {

            workItemId: Number(item.workItemId) || "",

            workActivity: item.workActivity || "",

            workActivities:
              selectedWorkItem?.workActivities || [],

            fromChainage: item.fromChainage || "",

            toChainage: item.toChainage || "",

            side: item.side || "",

            remarks: item.remarks || "",

            locationId: item.locationId || "",

            UOM: item.UOM || "",

            nos: item.nos || "",

            quantity:
              item.projectQuantity ||
              item.quantity ||
              "",

            workQuantity:
              item.quantity || "",

            length:
              item.length || "",

            breadth:
              item.breadth || "",

            depth:
              item.depth || ""

          };

        });

      if (pointData.length > 0) {
        pointData.forEach((_, idx) => performChainageValidation(pointData, idx));
        setPoints(pointData);

      } else {

        setPoints([
          {
            point: "",
            workActivity: "",
            workActivities: [],
            workItemId: "",
            locationId: "",
            UOM: "",
            nos: "",
            quantity: "",
            workQuantity: "",
            fromChainage: "",
            toChainage: "",
            side: "",
            remarks: "",
            length: "",
            breadth: "",
            depth: ""
          }
        ]);

      }
      // setMaterials(

      //   res.materialItems || []

      // );
      const editedMaterials =
        await Promise.all(

          (res.materialItems || []).map(
            async material => {

              const vouchersRes =
                await DailyReportService
                  .getItemVouchers(
                    res.projectId || res.projectid,
                    res.locationId,
                    material.itemId,
                    res.reportDate
                  );

              const balanceRes =
                await DailyReportService
                  .getAvailableBalance(
                    material.stockOutVoucherNo,
                    material.itemId
                  );

              // return {
              //   ...material,

              //   vouchers:
              //     vouchersRes?.data?.data || [],

              //   availableBalance:
              //     balanceRes?.data?.data
              //       ?.availableBalance || 0
              // };

              const available =
                balanceRes?.data?.data?.availableBalance || 0;

              return {
                ...material,
                vouchers: vouchersRes?.data?.data || [],
                availableBalance: available,
                balance:
                  available -
                  Number(material.quantityUsed || 0) -
                  Number(material.quantityLost || 0) -
                  Number(material.quantityDamaged || 0) -
                  Number(material.quantityReturned || 0)
              };
            }
          )
        );

      // setMaterials(editedMaterials);
      if (editedMaterials.length > 0) {

        setMaterials(editedMaterials);
        setProjectItems(prevItems => {
          const updatedItems = [...prevItems];
          editedMaterials.forEach(m => {
            if (m.itemId && !updatedItems.some(item => Number(item.itemId) === Number(m.itemId))) {
              updatedItems.push({
                itemId: m.itemId,
                itemCode: m.itemCode,
                itemName: m.itemName,
                itemCategoryName: m.itemCategoryName
              });
            }
          });
          return updatedItems;
        });

      } else {

        setMaterials([
          {
            itemId: "",
            stockOutVoucherNo: "",
            vouchers: [],
            availableBalance: "",
            quantityUsed: "",
            quantityLost: "",
            quantityDamaged: "",
            quantityReturned: "",
            balance: "",
            notes: ""
          }
        ]);

      }
      // setLabours(

      //   res.labourItems || []

      // );

      // setPoints(extracted.map(p => ({ point: p })));

      if ((res.labourItems || []).length > 0) {

        setLabours(res.labourItems);

      } else {

        setLabours([
          {
            vendorId: "",
            skilledLabour: "",
            unSkilledLabour: "",
            notes: ""
          }
        ]);

      }
      reset({
        projectId: res.projectId || res.projectid,
        reportDate: res.reportDate?.split("T")[0],

        workItemId: res.workItemId,
        locationId: res.locationId,

        fromChainage: res.fromChainage,
        toChainage: res.toChainage,

        side: res.side,

        labourVendorId: res.labourVendorId,

        skilledLabour: res.skilledLabour,
        unskilledLabour: res.unskilledLabour,

        UOM: res.UOM,
        quantity: res.quantity,

        remarks: res.remarks,

        workStatus: res.workStatus || "WORKING",
        idleNote: res.idleNote || "",

        status: res.status || "Active",
      });

      setValue("workItemId", res.workItemId);
      setValue("locationId", res.locationId);
      setValue("labourVendorId", res.labourVendorId);

      await loadPreviousReports(res.projectid);
    } catch (err) {
      console.error("Error loading report:", err);
    } finally {
      setEditLoading(false); // ✅ STOP LOADING
    }
  };


  const checkExistingDpr = async () => {
    const projectId = getValues("projectId");
    const reportDate = getValues("reportDate");
    const locationId = getValues("locationId");

    if (
      !projectId ||
      !reportDate ||
      !locationId
    ) {
      return;
    }

    try {
      const hasPending = await checkPendingDpr();
      if (hasPending) {
        return;
      }

      const res = await DailyReportService.checkExisting(
        projectId,
        reportDate,
        locationId
      );

      const existing = res?.data?.data;

      if (existing?.id) {
        if (editMode && existing.id === reportId) {
          return;
        }

        const formattedDate = existing.reportDate
          ? utility.formatDateDMY(existing.reportDate)
          : (reportDate ? utility.formatDateDMY(reportDate) : "-");

        const isApproved =
          (existing.status || "").toUpperCase() === "APPROVED";

        if (isApproved) {
          showMessage(
            `A DPR for this Project, Location, and Date (${formattedDate}) is already APPROVED.\n\nYou cannot create or modify an approved DPR.\n\nRedirecting to Daily Reports view page...`,
            "warning",
            10000,
            () => navigate("/cpnl/dailyreport/view")
          );
        } else {
          showMessage(
            `A DPR already exists for this Project, Location, and Date (${formattedDate}) with status: ${existing.status || "Active"}.\n\nRedirecting to Daily Reports view page...`,
            "warning",
            10000,
            () => navigate("/cpnl/dailyreport/view")
          );
        }
      }
    } catch (err) {
      console.error("Error checking existing DPR:", err);
    }
  };


  const checkPendingDpr = async () => {

    const projectId = getValues("projectId");
    const locationId = getValues("locationId");

    if (!projectId || !locationId) {
      return false;
    }

    try {

      const res =
        await DailyReportService.checkPending(
          projectId,
          locationId
        );

      const pending =
        res?.data?.data;

      if (pending) {
        if (editMode && pending.id === reportId) {
          return false;
        }

        const pendingDateDisplay = pending.reportDate
          ? utility.formatDateDMY(pending.reportDate)
          : "Unknown";

        showMessage(
          `A Pending DPR already exists for this Project and Location.\n\n` +
          `Report Date: ${pendingDateDisplay}\n\n` +
          `Please approve, reject, or cancel the existing DPR before creating a new one.`,
          "error",

          10000
        );

        return true;
      }

      return false;

    } catch (err) {

      console.error(err);
      return false;

    }

  };

  const loadProjectStockOutItems =
    async (projectId, locationId) => {

      console.log("Project ID =", projectId);
      console.log("Location ID =", locationId);

      try {

        const res =
          await DailyReportService
            .getProjectStockOutItems(
              projectId,
              locationId
            );
        console.log("Items Response =", res.data);
        console.log("Items List =", res.data.data);

        setProjectItems(
          res?.data?.data || []
        );

        console.log("Project Items =", res?.data?.data);

      } catch (err) {

        console.error(err);

      }

    };

  // const handleItemChange = async (index, itemId) => {
  //   try {
  //     if (!itemId) {
  //       const updated = [...materials];
  //       updated[index].itemId = "";
  //       updated[index].vouchers = [];
  //       updated[index].stockOutVoucherNo = "";
  //       updated[index].availableBalance = "";
  //       updated[index].balance = "";
  //       setMaterials(updated);
  //       return;
  //     }

  //     const projectId = materials[index].projectId || getValues("projectId");
  //     const reportDate =
  //       getValues("reportDate");

  //     const res = await DailyReportService.getItemVouchers(projectId, itemId, reportDate);

  //     const updated = [...materials];
  //     updated[index].itemId = itemId;
  //     updated[index].vouchers = res?.data?.data || [];
  //     updated[index].stockOutVoucherNo = "";
  //     updated[index].availableBalance = "";

  //     setMaterials(updated);
  //   } catch (err) {
  //     console.error("Error loading item vouchers:", err);
  //   }
  // };

  const handleItemChange = async (index, itemId) => {

    const updated = [...materials];

    // First select the item
    updated[index].itemId = itemId;
    updated[index].stockOutVoucherNo = "";
    updated[index].availableBalance = "";
    updated[index].balance = "";
    updated[index].vouchers = [];

    setMaterials(updated);

    if (!itemId) return;

    try {
      const projectId = getValues("projectId");
      const locationId = getValues("locationId");
      const reportDate = getValues("reportDate");
      console.log(getValues("locationId"));
      const res = await DailyReportService.getItemVouchers(
        projectId,
        locationId,
        itemId,
        reportDate
      );

      updated[index].vouchers = res?.data?.data || [];

      setMaterials([...updated]);

    } catch (err) {
      console.error("Error loading item vouchers:", err);
    }
  };

  const handleVoucherChange = async (index, voucherNo) => {
    try {
      if (!voucherNo) {
        const updated = [...materials];
        updated[index].stockOutVoucherNo = "";
        updated[index].availableBalance = "";
        updated[index].balance = "";
        setMaterials(updated);
        return;
      }

      const itemId = materials[index].itemId;

      const isDuplicate = materials.some((row, i) =>
        i !== index &&
        Number(row.itemId) === Number(itemId) &&
        row.stockOutVoucherNo === voucherNo
      );

      if (isDuplicate) {

        showMessage(
          "This Item and Voucher already exists.",
          "error"
        );

        const updated = [...materials];
        updated[index].stockOutVoucherNo = "";
        updated[index].availableBalance = "";
        updated[index].balance = "";

        setMaterials(updated);

        return;
      }

      const res = await DailyReportService.getAvailableBalance(
        voucherNo,
        itemId
      );

      const updated = [...materials];
      updated[index].stockOutVoucherNo = voucherNo;
      updated[index].availableBalance = res?.data?.data?.availableBalance || 0;
      updated[index].balance = updated[index].availableBalance;

      setMaterials(updated);
    } catch (err) {
      console.error("Error loading available balance:", err);
    }
  };

  useEffect(() => {
    const loadUoms = async () => {
      try {
        const res = await UomService.getActive();

        setUoms(Array.isArray(res) ? res : res?.data || []);

      } catch (err) {
        console.error("UOM load error:", err);
      }
    };

    loadUoms();
  }, []);

  // useEffect(() => {

  //   const loadLocations = async () => {

  //     try {

  //       const res = await LocationService.getActive();

  //       const list = res?.data || res || [];

  //       setLocations(list);

  //     } catch (err) {

  //       console.error("Location load error:", err);

  //     }

  //   };

  //   loadLocations();

  // }, []);

  const loadProjectLocations = async (projectId) => {

    if (!projectId) {
      setLocations([]);
      return;
    }

    try {

      // const res =
      //   await DailyReportService.getProjectLocations(projectId);

      const res =
        await ProjectLocationService.getActiveLocationsForDPR(projectId);

      console.log("PROJECT LOCATIONS RESPONSE =", res);
      console.log("PROJECT LOCATIONS DATA =", res.data);

      const list =
        res?.data || [];

      setLocations(list);

    } catch (err) {

      console.error(
        "Error loading project locations:",
        err
      );

      setLocations([]);
    }
  };

  useEffect(() => {
    if (selectedLocationId) {
      setPoints(prev =>
        prev.map(row => ({
          ...row,
          locationId: row.locationId || selectedLocationId
        }))
      );
    }
  }, [selectedLocationId]);



  // useEffect(() => {
  //   loadStockOutVouchers();
  // }, []);


  // const loadStockOutVouchers = async () => {

  //   try {

  //     const res = await StockOutService.getAll();

  //     const list =
  //       res?.data?.data ||
  //       res?.data ||
  //       [];

  //     setStockOutVouchers(list);

  //   } catch (err) {

  //     console.error(
  //       "Error loading stock vouchers:",
  //       err
  //     );

  //   }

  // };

  // const loadVendorsByCategory = async (categoryId) => {
  //   if (!categoryId) {
  //     setVendors([]);
  //     return;
  //   }

  //   try {
  //     const res = await VendorService.getByCategory(categoryId);

  //     const vendorList = res?.data || res || [];

  //     setVendors(vendorList);

  //   } catch (err) {
  //     console.error("Vendor load error:", err);
  //   }
  // };

  useEffect(() => {

    const loadLabourVendors = async () => {

      try {

        const catRes = await VendorCategoryService.getActive();
        const categories = catRes?.data || catRes || [];

        // find category containing "labour"
        const labourCategory = categories.find(
          c => c.vendorCategoryName?.toLowerCase().includes("labour")
        );

        if (!labourCategory) {
          console.log("Labour category not found");
          return;
        }

        const vendorRes = await VendorService.getByCategory(labourCategory.id);

        const vendorList =
          vendorRes?.data?.data ||
          vendorRes?.data ||
          vendorRes ||
          [];

        setVendors(vendorList);

      } catch (err) {

        console.error("Labour vendor load error:", err);

      }

    };

    loadLabourVendors();

  }, []);

  // useEffect(() => {
  //   const loadWorkItems = async () => {
  //     try {
  //       const res = await WorkItemService.getAll(1, 1000);

  //       const list = res?.data || [];

  //       setWorkItems(list);

  //     } catch (err) {
  //       console.error("Work item load error:", err);
  //     }
  //   };

  //   loadWorkItems();
  // }, []);

  const loadProjectWorkItems = async (projectId) => {
    if (!projectId) {
      setWorkItems([]);
      return;
    }

    try {
      // const res = await Projectservice.getByProjectId(projectId);
      const res = await ProjectService.getById(projectId);
      console.log("PROJECT DATA:", res);
      const categoryName =
        res?.data?.projectCategoryName || "";

      console.log("PROJECT CATEGORY NAME =", categoryName);
      setSelectedProjectCategoryCode(categoryName);

      // setShowMeasurementFields(
      //   categoryName === "Civil Works"
      //   // || categoryName === "Water Utility"
      // );

      setShowMeasurementFields(
        categoryName?.trim() === "Civil Works"
      );

      // setWorkItems(res?.data || []);
      // setWorkItems(res?.data?.projectWorkItems || []);

      const projectItems = (res?.data?.projectWorkItems || []).filter(
        (p) => Number(p.isActive) === 1 || p.isActive === true || p.status === "Active"
      );

      // LOAD MASTER WORK ITEMS
      const workItemRes = await WorkItemService.getAll(1, 1000);

      const masterItems =
        workItemRes?.data?.data ||
        workItemRes?.data ||
        [];

      // MERGE PROJECT ITEMS WITH MASTER WORK ITEMS
      const mergedItems = projectItems.map((p) => {

        const master = masterItems.find(
          m => Number(m.id) === Number(p.workItemId)
        );

        return {
          ...p,

          // TAKE WORK ACTIVITIES FROM MASTER
          workActivities:
            master?.workActivities || []
        };
      });

      // setWorkItems(mergedItems);
      setWorkItems(mergedItems);

      return mergedItems;
    } catch (err) {
      console.error("Error loading project work items:", err);
    }
  };


  // const handleWorkItemChange = (index, workItemId) => {
  //   const selected = workItems.find(
  //     w => Number(w.workItemId) === Number(workItemId)
  //   );

  //   const updated = [...points];

  //   updated[index].workItemId = workItemId;
  //   // updated[index].UOM = selected?.uom || "";
  //   updated[index].UOM = "";
  //   updated[index].quantity = selected?.quantity || "";
  //   updated[index].length = "";
  //   updated[index].breadth = "";
  //   updated[index].depth = "";
  //   updated[index].workQuantity = "";
  //   updated[index].workActivities =
  //     selected?.workActivities || [];

  //   updated[index].workActivity = "";



  //   setPoints(updated);
  // };

  const handleWorkItemChange = (index, workItemId) => {

    const selected = workItems.find(
      w => Number(w.workItemId) === Number(workItemId)
    );

    const updated = [...points];

    updated[index].workItemId = workItemId;

    // NEW
    updated[index].workItemCode = selected?.workItemCode || "";
    updated[index].workItemName =
      selected?.workItemDescription ||
      selected?.workItemName ||
      "";

    updated[index].UOM = "";

    updated[index].quantity = selected?.quantity || "";

    updated[index].nos = "";
    updated[index].length = "";
    updated[index].breadth = "";
    updated[index].depth = "";
    updated[index].workQuantity = "";
    updated[index].workActivities = selected?.workActivities || [];
    updated[index].workActivity = "";

    setPoints(updated);
  };

  // // LOAD PROJECTS
  // const loadProjects = async () => {
  //   const emp = StorageService.loginData();
  //   const comp = StorageService.activeCompany();

  //   try {
  //     let projectsData = [];

  //     // SUPER ADMIN → ALL PROJECTS BY COMPANY
  //     if (
  //       emp.roleName === "Super Admin" ||
  //       emp.roleName === "SuperAdmin" ||
  //       Number(emp.roleId) === 1
  //     ) {
  //       const res = await ProjectService.getActive(comp.companyId);

  //       projectsData = (res || []).map(p => ({
  //         projectId: p.id,
  //         projectName: p.projectName
  //       }));
  //     }
  //     //  NORMAL USER → ASSIGNED PROJECTS
  //     else {
  //       const res = await ProjectService.getAssignedProjects(
  //         comp.companyId,
  //         emp.employeeId
  //       );
  //       console.log("Projects dropdown data:", projects);
  //       projectsData = res?.data?.data || [];
  //     }

  //     setProjects(projectsData);
  //   } catch (err) {
  //     console.error("Error loading projects:", err);
  //     setProjects([]);
  //   }
  // };


  const loadProjects = async () => {
    const emp = StorageService.loginData();
    const comp = StorageService.activeCompany();

    try {
      let projectsData = [];

      // SUPER ADMIN + DATA ADMIN → ALL PROJECTS
      const isPrivilegedProjectUser =
        emp.roleName === "Super Admin" ||
        emp.roleName === "SuperAdmin" ||
        emp.roleName === "Data Admin" ||
        Number(emp.roleId) === 1 ||
        Number(emp.roleId) === 2;

      if (isPrivilegedProjectUser) {

        // Get ALL active projects of the company
        const res = await ProjectService.getActive(
          comp.companyId
        );

        projectsData = (res || []).map(p => ({
          projectId: p.id,
          projectName: p.projectName,
          projectCode: p.projectCode,
          projectCategoryCode: p.projectCategoryCode
        }));

      } else {

        // NORMAL USER → ONLY ASSIGNED PROJECTS
        const res = await ProjectService.getAssignedProjects(
          comp.companyId,
          emp.employeeId
        );

        projectsData = (res?.data?.data || []).map(p => ({
          projectId: p.projectId,
          projectName: p.projectName,
          projectCode: p.projectCode,
          projectCategoryCode: p.projectCategoryCode
        }));
      }

      setProjects(projectsData);

      console.log(
        "ROLE ID =",
        emp.roleId
      );

      console.log(
        "PROJECTS LOADED =",
        projectsData
      );

    } catch (err) {
      console.error("Error loading projects:", err);
      setProjects([]);
    }
  };
  // const loadProjects = async () => {
  //   const emp = StorageService.loginData();
  //   const comp = StorageService.activeCompany();

  //   try {
  //     let projectsData = [];

  //     // SUPER ADMIN → ALL PROJECTS
  //     if (
  //       emp.roleName === "Super Admin" ||
  //       emp.roleName === "SuperAdmin" ||
  //       Number(emp.roleId) === 1
  //     ) {
  //       const res = await ProjectService.getActive(comp.companyId);

  //       projectsData = (res || []).map(p => ({
  //         projectId: p.id,
  //         projectName: p.projectName,
  //         projectCode: p.projectCode,
  //         projectCategoryCode: p.projectCategoryCode
  //       }));
  //     }
  //     // NORMAL USER → ASSIGNED PROJECTS
  //     else {
  //       const res = await ProjectService.getAssignedProjects(
  //         comp.companyId,
  //         emp.employeeId
  //       );

  //       projectsData = (res?.data?.data || []).map(p => ({
  //         projectId: p.projectId,
  //         projectName: p.projectName,
  //         projectCode: p.projectCode,
  //         projectCategoryCode: p.projectCategoryCode
  //       }));
  //     }


  //     setProjects(projectsData);
  //     console.log(
  //       "FIRST PROJECT FULL DATA =",
  //       JSON.stringify(projectsData[0], null, 2)
  //     );
  //   } catch (err) {
  //     console.error("Error loading projects:", err);
  //     setProjects([]);
  //   }
  // };



  // MESSAGE HANDLER
  // const showMessage = (text, type = "error") => {
  //   setMessage(text);
  //   setMsgType(type);
  // };

  const showMessage = (
    text,
    type = "error",
    duration = 10000,
    onCloseCallback = null
  ) => {
    setMessage(text);
    setMsgType(type);
    setMessageDuration(duration);
    setMessageOnClose(() => (typeof onCloseCallback === "function" ? onCloseCallback : null));
  };

  // POINT ROW FUNCTIONS
  // const addRow = () => setPoints([...points, { point: "" }]);
  const addRow = () => {
    const defaultSource = points.length > 0
      ? ([...points].reverse().find(
        row => (row.fromChainage !== "" && row.fromChainage !== undefined && row.fromChainage !== null) ||
          (row.toChainage !== "" && row.toChainage !== undefined && row.toChainage !== null)
      ) || points[points.length - 1])
      : {};

    const newRow = {
      point: "",
      workActivity: "",
      workActivities: [],
      workItemId: "",
      locationId: selectedLocationId || "",
      UOM: "",
      nos: "",
      quantity: "",
      workQuantity: "",
      fromChainage: showChainage ? (defaultSource.fromChainage ?? "") : "",
      toChainage: showChainage ? (defaultSource.toChainage ?? "") : "",
      side: "",
      remarks: "",
      length: "",
      breadth: "",
      depth: ""
    };

    setPoints([...points, newRow]);
  };

  const deleteRow = (index) => {
    const updated = [...points];
    updated.splice(index, 1);
    setPoints(updated);
  };

  const addMaterialRow = () => {
    setMaterials([
      ...materials,
      {
        itemId: "",
        stockOutVoucherNo: "",
        vouchers: [],
        quantityUsed: "",
        quantityLost: "",
        quantityDamaged: "",
        quantityReturned: "",
        balance: "",
        notes: ""
      }
    ]);
  };

  const deleteMaterialRow = (index) => {
    const updated = [...materials];

    updated.splice(index, 1);

    setMaterials(updated);
  };


  const addLabourRow = () => {
    setLabours([
      ...labours,
      {
        vendorId: "",
        skilledLabour: "",
        unSkilledLabour: "",
        notes: ""
      }
    ]);
  };

  const deleteLabourRow = (index) => {
    const updated = [...labours];

    updated.splice(index, 1);

    setLabours(updated);
  };


  const updatePoint = (index, value) => {
    const updated = [...points];
    updated[index].point = value;
    setPoints(updated);
  };

  const hasValidPoint = () => {
    return points.some(p => p.point.trim() !== "");
  };


  // SUBMIT HANDLER
  //   const onSubmit = async (data) => {

  //     if (!data.projectId) {
  //       showMessage("Please select a project.");
  //       return;
  //     }

  //     if (!data.reportDate) {
  //       showMessage("Please select report date.");
  //       return;
  //     }

  //     if (!hasValidPoint()) {
  //       showMessage("Please add at least one description point.");
  //       return;
  //     }

  //     setLoading(true);

  //     // const firstRow = points[0];

  //     // data.workItemId = firstRow.workItemId;
  //     // // data.UOM = firstRow.UOM;
  //     // // data.quantity = firstRow.quantity;
  //     // data.workQuantity = firstRow.workQuantity;
  //     // data.fromChainage = firstRow.fromChainage;
  //     // data.toChainage = firstRow.toChainage;
  //     // data.side = firstRow.side;
  //     // data.remarks = firstRow.remarks;

  //     for (const row of points) {
  //       const payload = {
  //         ...data,
  //         workItemId: row.workItemId,
  //         workQuantity: row.workQuantity,
  //         fromChainage: row.fromChainage,
  //         toChainage: row.toChainage,
  //         side: row.side,
  //         remarks: row.remarks,
  //       };

  //       await DailyReportService.create(payload);
  //     }

  //     try {
  //       const emp = StorageService.loginData();
  //       data.updatedBy = emp.employeeId;

  //       // ONLY TODAY'S POINTS
  //       const todayText = points
  //         .filter((p) => p.point.trim() !== "")
  //         .map((p, i) => `${i + 1}. ${p.point}`)
  //         .join("\n");

  //       data.description = todayText;

  //       if (!editMode) {
  //         data.status = "Active";
  //         data.createdBy = emp.employeeId;
  //       }

  //       console.log("DATA SENDING TO BACKEND:", data);


  //       // let res;
  //       // if (editMode) res = await DailyReportService.update(reportId, data);
  //       // else res = await DailyReportService.create(data);

  //       let res;

  // if (editMode) {
  //   res = await DailyReportService.update(reportId, data);
  // } else {
  //   for (const row of points) {
  //     const payload = {
  //       ...data,
  //       workItemId: row.workItemId,
  //       workQuantity: row.workQuantity,
  //       fromChainage: row.fromChainage,
  //       toChainage: row.toChainage,
  //       side: row.side,
  //       remarks: row.remarks,
  //     };

  //     await DailyReportService.create(payload);
  //   }

  //   res = { status: true };
  // }

  //       console.log("SAVE RESPONSE:", res);

  //       if (res && res.status === true) {

  //         showMessage(
  //           editMode
  //             ? "Daily Report updated successfully!"
  //             : "Daily Report added successfully!",
  //           "success"
  //         );

  //         setTimeout(() => {
  //           navigate("/cpnl/dailyreport/view");
  //         }, 1000);

  //       } else {

  //         showMessage(res?.message || "Something went wrong while saving.");

  //       }

  //       // showMessage("Something went wrong while saving.");
  //     } catch (error) {

  //       console.error("SAVE ERROR:", error);

  //       const backendMessage =
  //         error?.response?.data?.message ||
  //         "Error saving Daily Report.";

  //       showMessage(backendMessage);


  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  const onSubmit = async (data) => {

    if (!data.projectId) {
      showMessage("Please select a project.");
      return;
    }

    if (!data.reportDate) {
      showMessage("Please select report date.");
      return;
    }

    if (!data.locationId) {
      showMessage("Please select location.");
      return;
    }

    if (data.workStatus === "COMPLETED" && !data.idleNote?.trim()) {
      showMessage("Please enter a note for completed status.");
      return;
    }

    if (data.workStatus === "WORKING") {
      const updated = [...points];
      let hasError = false;
      let firstErrorMsg = "";

      updated.forEach((row, idx) => {
        if (row.workItemId) {
          performChainageValidation(updated, idx);
          if (row.fromChainageError || row.toChainageError) {
            hasError = true;
            if (!firstErrorMsg) {
              firstErrorMsg = row.fromChainageError || row.toChainageError;
            }
          }
        }
      });

      if (hasError) {
        setPoints(updated);
        showMessage(`Validation Error: ${firstErrorMsg}`);
        return;
      }
    }

    // if (data.workStatus === "WORKING" && !hasValidPoint()) {
    //   showMessage("Please add at least one description point.");
    //   return;
    // }

    setLoading(true);

    try {
      const hasPending = await checkPendingDpr();
      if (hasPending) {
        setLoading(false);
        return;
      }

      const emp = StorageService.loginData();

      const selectedDateStr = data.reportDate;
      const todayStr = getTodayDate();
      if (selectedDateStr > todayStr) {
        showMessage("Future date is not allowed");
        setLoading(false);
        return;
      }

      const isPrivileged =
        Number(emp?.roleId) === 1 || Number(emp?.roleId) === 2;

      if (!isPrivileged && selectedDateStr < todayStr) {
        showMessage("Only Super Admin and Data Admin can select a past date");
        setLoading(false);
        return;
      }

      // ✅ description
      // const todayText = points
      //   .filter((p) => p.point.trim() !== "")
      //   .map((p, i) => `${i + 1}. ${p.point}`)
      //   .join("\n");

      const todayText = points
      // const payload = {
      //   ...data,
      //   description: todayText,
      //   createdBy: emp.employeeId,
      //   updatedBy: emp.employeeId,
      //   status: "PENDING",
      //   materialItems: materials,

      //   labourItems: labours,

      //   // 🔥 MAIN CHANGE
      //   items: points
      //     .filter(p => p.workItemId) // empty rows remove
      //     .map(p => ({
      //       workItemId: p.workItemId,
      //       workActivity: p.workActivity,
      //       locationId: p.locationId,
      //       UOM: p.UOM,
      //       fromChainage: p.fromChainage,
      //       toChainage: p.toChainage,
      //       workQuantity: p.workQuantity,
      //       side: p.side,
      //       remarks: p.remarks,
      //       description: p.point,
      //       length: p.length,
      //       breadth: p.breadth,
      //       depth: p.depth
      //     }))
      // };

      const hasMaterial = materials.some(m => m.itemId);

      const hasLabour = labours.some(l => l.vendorId);

      if (data.workStatus === "WORKING" && !hasMaterial && !hasLabour) {
        showMessage(
          "Warning: Material Consumption(Items) and Labour Progress(Vendors) are not added.",
          "warning",
          10000
        );
      }

      const payload = {

        projectId: Number(data.projectId),

        reportDate: data.reportDate,

        locationId: Number(data.locationId),

        workStatus: data.workStatus,

        idleNote: (data.workStatus === "IDLE" || data.workStatus === "COMPLETED") ? data.idleNote.trim() : null,

        createdBy: emp.employeeId,
        updatedBy: emp.employeeId,
        roleId: Number(emp.roleId),
        status: "PENDING",

        items: data.workStatus === "WORKING" ? points
          .filter(p => p.workItemId)
          .map(p => ({

            locationId: p.locationId,

            workItemId: p.workItemId,
            workItemCode: p.workItemCode,
            workItemName: p.workItemName,

            workActivity: p.workActivity,

            fromChainage: p.fromChainage,

            toChainage: p.toChainage,

            // description: p.point,

            UOM: p.UOM,
            nos: p.nos,

            side: p.side,

            workQuantity: p.workQuantity,

            length: p.length,

            breadth: p.breadth,

            depth: p.depth,

            remarks: p.remarks

          })) : [],

        materialItems: data.workStatus === "WORKING" ? materials
          .filter(m => m.itemId)
          .map(m => ({
            stockOutVoucherNo: m.stockOutVoucherNo,
            itemId: m.itemId,
            availableBalance: m.availableBalance,
            quantityUsed: m.quantityUsed || 0,
            quantityLost: m.quantityLost || 0,
            quantityDamaged: m.quantityDamaged || 0,
            quantityReturned: m.quantityReturned || 0,
            notes: m.notes
          })) : [],



        // labourItems: data.workStatus === "WORKING" ? labours
        //   .filter(l => l.vendorId)
        //   .map(l => ({

        //     vendorId: l.vendorId,

        //     skilledLabour: l.skilledLabour || 0,

        //     unSkilledLabour: l.unSkilledLabour || 0,

        //     notes: l.notes

        //   })) : []

        labourItems: data.workStatus === "WORKING"
          ? labours
            .filter(l => l.vendorId)
            .map(l => ({
              vendorId: l.vendorId,

              skilledLabour: parseInt(l.skilledLabour || 0, 10),

              unSkilledLabour: parseInt(l.unSkilledLabour || 0, 10),

              notes: l.notes
            }))
          : []

      };
      console.log("FINAL PAYLOAD:", payload);
      console.log("ITEMS =", payload.items);
      console.log("MATERIALS =", payload.materialItems);
      console.log("LABOUR =", payload.labourItems);

      console.log("Saving item:", payload);

      let res;

      if (editMode) {
        res = await DailyReportService.update(reportId, payload);
      } else {
        res = await DailyReportService.create(payload);
      }

      if (res && res.status === true) {
        // showMessage("Saved successfully", "success");

        // showMessage(
        //   res.message,
        //   "success"
        // );

        // if (res.message?.includes("Warning")) {
        //   showMessage(res.message, "warning", 10000);
        // } else {
        //   showMessage(res.message, "success", 3000);
        // }



        // setTimeout(() => {
        //   navigate("/cpnl/dailyreport/view");
        // }, 1000);

        if (res && res.status === true) {
          const isWarning = res.message?.includes("Warning");

          if (isWarning) {
            // Show warning for 7 seconds
            showMessage(res.message, "warning", 7000);
          } else {
            // Normal success message
            showMessage(res.message, "success", 3000);
          }

          // Warning → wait 7 seconds
          // Success → wait 600 milliseconds
          const redirectDelay = isWarning ? 7000 : 600;

          setTimeout(() => {
            navigate("/cpnl/dailyreport/view");
          }, redirectDelay);
        }
      } else {
        showMessage(res?.message || "Save failed");
      }

      console.log("Project =", data.projectId);
      console.log("Location =", data.locationId);
    }
    // catch (error) {
    //   console.error(error);

    //   showMessage(
    //     error?.response?.data?.message || "Error saving"
    //   );
    // }
    catch (error) {
      console.log("Status :", error.response?.status);
      console.log("Response :", error.response?.data);
      console.error(error);

      const reportId = error?.response?.data?.reportId;
      const reportStatus = error?.response?.data?.reportStatus;

      if (reportId) {
        const report = await DailyReportService.getById(reportId);
        await loadReportForEdit(reportId);

        if (reportStatus === "APPROVED") {
          showMessage(
            "DPR already approved. Modification not allowed.",
            "error",
            10000
          );
        } else {
          showMessage(
            "DPR already exists. Existing data loaded for modification.",
            "warning",
            10000
          );
        }
        return;
      }

      showMessage(
        error?.response?.data?.message ||
        "Unable to save daily report. Please try again.",
        "error",
        10000
      );
    }
    finally {
      setLoading(false);
    }
  };

  const calculateBalance = (row) => {

    return (

      Number(row.availableBalance || 0)

      -

      Number(row.quantityUsed || 0)

      -

      Number(row.quantityLost || 0)

      -

      Number(row.quantityDamaged || 0)

      -

      Number(row.quantityReturned || 0)

    );

  };

  const handleCancel = () => {
    reset();
    setPoints([]);
    setEditMode(false);
    setReportId(null);

    navigate("/cpnl/dailyreport/view");
  };

  // const updateMeasurement = (index, field, value) => {
  //   const updated = [...points];

  //   updated[index][field] = value;
  //   const nos = Number(updated[index].nos || 0);

  //   const l = Number(updated[index].length || 0);
  //   const b = Number(updated[index].breadth || 0);
  //   const d = Number(updated[index].depth || 0);

  //   updated[index].workQuantity = (nos * (l * b * d)).toFixed(3);



  //   setPoints(updated);
  // };
  const handlePointChange = (index, field, value) => {

    const updated = [...points];

    updated[index][field] = value;

    if (isCivil) {

      const nos = Number(updated[index].nos || 0);
      const length = Number(updated[index].length || 0);
      const breadth = Number(updated[index].breadth || 0);
      const depth = Number(updated[index].depth || 0);

      updated[index].workQuantity = (
        nos *
        length *
        breadth *
        depth
      ).toFixed(3);

    }

    setPoints(updated);
  };
  const totalSkilledLabour = labours.reduce(
    (sum, row) => sum + Number(row.skilledLabour || 0),
    0
  );

  const totalUnSkilledLabour = labours.reduce(
    (sum, row) => sum + Number(row.unSkilledLabour || 0),
    0
  );

  const grandTotalLabour =
    totalSkilledLabour + totalUnSkilledLabour;

  return (
    <>
      <Breadcrumb
        pageTitle={editMode ? "Modify Daily Report" : "Add Daily Report"}
        secondTitle="Daily Reports"
      />

      {/* {message && (
        <div
          className={`alert alert-${msgType === "success" ? "success" : "danger"} alert-dismissible fade show`}
        >
          {message}
          <button className="btn-close" onClick={() => setMessage("")}></button>
        </div>
      )} */}


      {/* <MessageDialog
        message={message}
        type={msgType}
        setMessage={setMessage}
        setMsgType={setMsgType}
      /> */}

      <MessageDialog
        message={message}
        type={msgType}
        duration={messageDuration}
        setMessage={setMessage}
        setMsgType={setMsgType}
        onClose={() => {
          if (typeof messageOnClose === "function") {
            const cb = messageOnClose;
            setMessageOnClose(null);
            cb();
          }
        }}
      />

      <div className="card p-4 shadow-sm">
        {editLoading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary"></div>
            <div className="mt-2 text-muted">Loading data...</div>
          </div>
        ) : (
          <form
            onSubmit={handleSubmit(
              onSubmit,
              (errors) => {
                if (errors.projectId) {
                  showMessage("Please select a project.");
                } else if (errors.reportDate) {
                  showMessage("Please select a report date.");
                }
              }
            )}
          >
            {/* PROJECT + DATE */}
            <div className="row mb-3">
              <div className="col-md-4">
                <label className="form-label">Project <span className="text-danger">*</span></label>
                <select
                  className="form-select"
                  {...register("projectId", { required: true, valueAsNumber: true })}
                  // onChange={(e) => {
                  //   const projectId = e.target.value;
                  //   setValue("projectId", projectId);
                  //   setValue("locationId", "");
                  //   loadPreviousReports(projectId);
                  //   loadProjectWorkItems(projectId);
                  //   loadProjectLocations(projectId);
                  //   loadProjectStockOutItems(projectId,);
                  //   setTimeout(() => {
                  //     checkExistingDpr();
                  //   }, 300);
                  // }}
                  onChange={async (e) => {

                    const projectId = e.target.value;

                    setValue("projectId", projectId);
                    setValue("locationId", "");

                    setProjectItems([]);     // Clear old items
                    setMaterials([
                      {
                        itemId: "",
                        stockOutVoucherNo: "",
                        vouchers: [],
                        availableBalance: "",
                        quantityUsed: "",
                        quantityLost: "",
                        quantityDamaged: "",
                        quantityReturned: "",
                        balance: "",
                        notes: ""
                      }
                    ]);

                    await loadPreviousReports(projectId);
                    await loadProjectWorkItems(projectId);
                    await loadProjectLocations(projectId);

                    // setTimeout(() => {
                    //   checkExistingDpr();
                    // }, 300);

                    setTimeout(async () => {

                      await checkPendingDpr();

                      await checkExistingDpr();

                    }, 300);

                  }}

                >
                  <option value="">Select Project</option>
                  {projects.map((p) => (
                    <option key={p.projectId} value={p.projectId}>
                      {p.projectName}-{p.projectCode}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-4">
                <label className="form-label">Report Date <span className="text-danger">*</span></label>
                <input
                  type="date"
                  className="form-control"
                  {...register("reportDate", { required: true })}
                  min={isPrivilegedDateUser ? undefined : getTodayDate()}
                  max={getTodayDate()}
                  onChange={(e) => {
                    setValue(
                      "reportDate",
                      e.target.value
                    );

                    setTimeout(async () => {
                      const hasPending = await checkPendingDpr();
                      if (!hasPending) {
                        await checkExistingDpr();
                      }
                    }, 300);
                  }}
                />
              </div>

              <div className="col-md-4">
                <label className="form-label">Location  <span className="text-danger">*</span> </label>
                {/* <select
                  className="form-select"
                  {...register("locationId", { valueAsNumber: true })}
                > */}
                <select
                  className="form-select"
                  {...register("locationId", { valueAsNumber: true })}
                  // onChange={(e) => {
                  //   const locationId = e.target.value;

                  //   // setValue("locationId", locationId);

                  //   setValue(
                  //     "locationId",
                  //     e.target.value
                  //   );

                  //   setTimeout(() => {
                  //     checkExistingDpr();
                  //   }, 300);

                  //   setPoints(prev =>
                  //     prev.map(row => ({
                  //       ...row,
                  //       locationId
                  //     }))
                  //   );
                  // }}
                  onChange={(e) => {

                    const locationId = e.target.value;

                    setValue("locationId", locationId);

                    // Reset Work Progress
                    setPoints([
                      {
                        point: "",
                        workActivity: "",
                        workActivities: [],
                        workItemId: "",
                        locationId: locationId,
                        UOM: "",
                        nos: "",
                        quantity: "",
                        workQuantity: "",
                        fromChainage: "",
                        toChainage: "",
                        side: "",
                        remarks: "",
                        length: "",
                        breadth: "",
                        depth: ""
                      }
                    ]);

                    // Reset Material Consumption
                    setMaterials([
                      {
                        itemId: "",
                        stockOutVoucherNo: "",
                        vouchers: [],
                        availableBalance: "",
                        quantityUsed: "",
                        quantityLost: "",
                        quantityDamaged: "",
                        quantityReturned: "",
                        balance: "",
                        notes: ""
                      }
                    ]);

                    // Reset Labour
                    setLabours([
                      {
                        vendorId: "",
                        skilledLabour: "",
                        unSkilledLabour: "",
                        notes: ""
                      }
                    ]);

                    // Clear previously loaded items
                    setProjectItems([]);

                    const projectId = getValues("projectId");

                    if (projectId && locationId) {

                      loadProjectStockOutItems(
                        projectId,
                        locationId
                      );

                      setTimeout(async () => {
                        const hasPending = await checkPendingDpr();
                        if (!hasPending) {
                          await checkExistingDpr();
                        }
                      }, 300);

                    }

                    setPoints(prev => {
                      const updated = prev.map(row => ({
                        ...row,
                        locationId
                      }));
                      updated.forEach((_, idx) => performChainageValidation(updated, idx));
                      return updated;
                    });
                  }}
                >
                  <option value="">Select Location</option>

                  {locations.map((loc) => (
                    <option
                      key={loc.id}
                      value={loc.locationId}
                    >
                      {loc.locationName}
                    </option>
                  ))}

                </select>
              </div>

            </div>


            <div className="row mb-3">
              <div className="col-md-4">
                <label className="form-label">
                  Work Status <span className="text-danger">*</span>
                </label>
                <select
                  className="form-select"
                  {...register("workStatus", {
                    required: true,
                    onChange: (event) => {
                      if (event.target.value === "WORKING") {
                        setValue("idleNote", "");
                      }
                    }
                  })}
                >
                  <option value="WORKING">Working</option>
                  <option value="IDLE">Idle</option>
                  {/* <option value="COMPLETED">Completed</option> */}
                </select>
              </div>

              {(workStatus === "IDLE" || workStatus === "COMPLETED") && (
                <div className="col-md-8">
                  <label className="form-label">
                    Note <span className="text-danger">*</span>
                  </label>
                  <textarea
                    className="form-control"
                    rows="2"
                    placeholder={workStatus === "COMPLETED" ? "Enter completion notes or remarks" : "Enter the reason or details for idle status"}
                    {...register("idleNote", {
                      validate: value =>
                        (workStatus !== "IDLE" && workStatus !== "COMPLETED") ||
                        Boolean(value?.trim()) ||
                        "Note is required"
                    })}
                  />
                  {errors.idleNote && (
                    <div className="text-danger small mt-1">
                      {errors.idleNote.message}
                    </div>
                  )}
                </div>
              )}
            </div>




            {/* <div className="row mb-3">



              <div className="col-md-4">
                <label className="form-label">Labour Vendor</label>

                <select
                  className="form-select"
                  {...register("labourVendorId", { valueAsNumber: true })}
                >
                  <option value="">Select Labour Vendor</option>

                  {vendors.map((v) => {
                    const contactName = [v.firstName, v.lastName].filter(Boolean).join(" ").trim();
                    const displayName = contactName ? `${v.vendorName} - ${contactName}` : (v.vendorName || "");
                    return (
                      <option key={v.id} value={v.id}>
                        {displayName}
                      </option>
                    );
                  })}

                </select>

              </div>


              <div className="col-md-4">

                <label className="form-label">Skilled Labour</label>
                <input type="number" min="0" className="form-control" {...register("skilledLabour", { valueAsNumber: true })} />
              </div>

              <div className="col-md-4">
                <label className="form-label">Unskilled Labour</label>
                <input type="number" min="0" className="form-control" {...register("unskilledLabour", { valueAsNumber: true })} />
              </div>
            </div> */}



            {workStatus === "WORKING" && (
              <>
                <h5>Work Details</h5>
                <Tabs>
                  <TabList>
                    <Tab>Work Progress</Tab>
                    <Tab>Material Consumption</Tab>
                    <Tab>Working Labour</Tab>
                  </TabList>
                  <TabPanel><div className="table-responsive" style={{ overflowX: 'auto' }}>
                    <table className="table table-bordered table-striped mt-2" style={{ minWidth: '1650px' }}>
                      <thead>
                        <tr>
                          {/* <th style={{ width: '100px' }}>From chainage</th>
                    <th style={{ width: '100px' }}>To chainage</th> */}

                          {/* {showMeasurementFields ? (
                      <th style={{ width: "200px" }}>Location</th>
                    ) : (
                      <>
                        <th style={{ width: "100px" }}>From Chainage</th>
                        <th style={{ width: "100px" }}>To Chainage</th>
                      </>
                    )} */}

                          {isCivil && (
                            <th style={{ width: '350px' }}>Location</th>
                          )}

                          {/* {(isElectrical || isWater) && ( */}
                          {showChainage && (
                            <>
                              <th style={{ width: '250px' }}>From Ch</th>
                              <th style={{ width: '250px' }}>To Ch</th>
                            </>
                          )}
                          <th style={{ width: '250px' }}>Side</th>
                          <th style={{ width: '350px' }}>Work Item</th>
                          {/* <th style={{ width: '350px' }}>Description</th> */}

                          <th style={{ width: '350px' }}>Work Activity</th>
                          <th style={{ width: '250px' }}>UOM</th>
                          {/* <th style={{ width: '100px' }}>Length</th> */}
                          {/* <th style={{ width: '100px' }}>Breadth</th>
                    <th style={{ width: '100px' }}>Depth</th> */}
                          {showMeasurementFields && (
                            <>
                              <th style={{ width: '200px' }}>Nos</th>
                              <th style={{ width: '220px' }}>Length</th>
                              <th style={{ width: '220px' }}>Breadth</th>
                              <th style={{ width: '220px' }}>Depth</th>
                            </>
                          )}

                          <th style={{ width: '250px' }}>Quantity</th>
                          <th style={{ width: '230px' }}>Work Quantity</th>
                          {/* <th style={{ width: '350px' }}>Description</th> */}
                          <th style={{ width: '250px' }}>Remarks</th>
                          <th style={{ width: '80px' }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {points.map((row, idx) => (
                          <tr key={idx}>
                            {/* <td>
                        <input
                          type="number"
                          step="any"
                          className="form-control"
                          value={row.fromChainage ?? ""}
                          onChange={(e) => {
                            if (Number(e.target.value) < 0) return;

                            const updated = [...points];
                            updated[idx].fromChainage = e.target.value;
                            setPoints(updated);
                          }}
                        />
                      </td>


                      <td>
                        <input
                          type="number"
                          step="any"
                          className="form-control"
                          value={row.toChainage ?? ""}
                          onChange={(e) => {
                            if (Number(e.target.value) < 0) return;

                            const updated = [...points];
                            updated[idx].toChainage = e.target.value;
                            setPoints(updated);
                          }}
                        />
                      </td> */}

                            {/* {showMeasurementFields ? (
                        <td>
                          <select
                            className="form-select"
                            value={row.locationId || ""}
                            onChange={(e) => {
                              const updated = [...points];
                              updated[idx].locationId = e.target.value;
                              setPoints(updated);
                            }}
                          >
                            <option value="">Select Location</option>

                            {locations.map((loc) => (
                              <option
                                key={loc.locationId}
                                value={loc.locationId}
                              >
                                {loc.locationName}
                              </option>
                            ))}
                          </select>
                        </td> */}
                            {/* {showMeasurementFields ? (

                        <td>
                          <input
                            type="text"
                            className="form-control"
                            value={
                              locations.find(
                                loc => String(loc.locationId) === String(row.locationId)
                              )?.locationName || ""
                            }
                            readOnly
                          />
                        </td>

                      ) : (
                        <>
                          <td>
                            <input
                              type="number"
                              step="any"
                              className="form-control"
                              value={row.fromChainage ?? ""}
                              onChange={(e) => {
                                const updated = [...points];
                                updated[idx].fromChainage = e.target.value;
                                setPoints(updated);
                              }}
                            />
                          </td>

                          <td>
                            <input
                              type="number"
                              step="any"
                              className="form-control"
                              value={row.toChainage ?? ""}
                              onChange={(e) => {
                                const updated = [...points];
                                updated[idx].toChainage = e.target.value;
                                setPoints(updated);
                              }}
                            />
                          </td>
                        </>
                      )} */}

                            {isCivil && (
                              // <td>
                              //   <select
                              //     className="form-select"
                              //     value={row.locationId || ""}
                              //     onChange={(e) => {
                              //       const updated = [...points];
                              //       updated[idx].locationId = e.target.value;
                              //       setPoints(updated);
                              //     }}
                              //   >
                              //     <option value="">Select Location</option>

                              //     {locations.map((loc) => (
                              //       <option
                              //         key={loc.locationId}
                              //         value={loc.locationId}
                              //       >
                              //         {loc.locationName}
                              //       </option>
                              //     ))}
                              //   </select>
                              // </td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  style={{ fontWeight: "bold", color: "black" }}
                                  value={
                                    locations.find(
                                      loc =>
                                        String(loc.locationId) ===
                                        String(row.locationId)
                                    )?.locationName || ""
                                  }
                                  readOnly
                                />
                              </td>
                            )}

                            {/* {(isElectrical || isWater) && ( */}
                            {showChainage && (
                              <>
                                <td>
                                  <input
                                    type="number"
                                    step="any"
                                    className={`form-control ${row.fromChainageError ? 'is-invalid' : ''}`}
                                    value={row.fromChainage ?? ""}
                                    onChange={(e) => {
                                      const updated = [...points];
                                      updated[idx].fromChainage = e.target.value;
                                      performChainageValidation(updated, idx);
                                      setPoints(updated);
                                    }}
                                  />
                                  {row.fromChainageError && (
                                    <div className="text-danger small mt-1">
                                      {row.fromChainageError}
                                    </div>
                                  )}
                                </td>

                                <td>
                                  <input
                                    type="number"
                                    step="any"
                                    className={`form-control ${row.toChainageError ? 'is-invalid' : ''}`}
                                    value={row.toChainage ?? ""}
                                    onChange={(e) => {
                                      const updated = [...points];
                                      updated[idx].toChainage = e.target.value;
                                      performChainageValidation(updated, idx);
                                      setPoints(updated);
                                    }}
                                  />
                                  {row.toChainageError && (
                                    <div className="text-danger small mt-1">
                                      {row.toChainageError}
                                    </div>
                                  )}
                                </td>
                              </>
                            )}

                            <td>
                              <select className="form-select"
                                // {...register("side")}
                                value={row.side || ""}
                                onChange={(e) => {
                                  const updated = [...points];
                                  updated[idx].side = e.target.value;
                                  setPoints(updated);
                                }}
                              >
                                <option value="">Select</option>
                                <option value="Left">Left</option>
                                <option value="Right">Right</option>
                                <option value="Straight">Straight</option>
                                <option value="Crossing">Crossing</option>

                              </select>
                            </td>

                            <td>
                              {/* <select
                          className="form-select"
                          {...register("workItemId", { valueAsNumber: true })}
                        >
                          <option value="">Select Work Item</option>

                          {workItems.map((w) => (
                            <option key={w.id} value={w.id}>
                              {w.workItemCode} - {w.workItemDescription}
                            </option>
                          ))}

                        </select> */}

                              <select
                                className="form-select"
                                // {...register("workItemId", { valueAsNumber: true })}
                                value={row.workItemId}
                                onChange={(e) =>
                                  handleWorkItemChange(idx, e.target.value)
                                }
                              >
                                <option value="">Select Work Item</option>

                                {workItems.map((w, index) => (
                                  <option
                                    key={w.id || `${w.workItemId}-${index}`}
                                    value={w.workItemId || ""}
                                  >
                                    {w.workItemCode}
                                  </option>
                                ))}

                              </select>
                            </td>
                            {/* <td>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Write point"
                          value={row.point}
                          onChange={(e) => updatePoint(idx, e.target.value)}
                        />
                      </td> */}
                            <td>
                              <select
                                className="form-select"
                                value={row.workActivity || ""}
                                onChange={(e) => {

                                  // const selectedActivity =
                                  //   row.workActivities.find(
                                  //     a =>
                                  //       a.workActivityName === e.target.value
                                  //   );

                                  const updated = [...points];

                                  // updated[idx].workActivity =
                                  //   e.target.value;

                                  // save into description
                                  // updated[idx].point =
                                  // e.target.value;


                                  // AUTO SET UOM
                                  // updated[idx].UOM =
                                  //   selectedActivity?.uom || "";


                                  // const selectedActivity =
                                  //   row.workActivities.find(
                                  //     a =>
                                  //       a.workActivityName === e.target.value
                                  //   );

                                  // updated[idx].workActivity =
                                  //   e.target.value;

                                  // updated[idx].point =
                                  //   e.target.value;

                                  // updated[idx].UOM =
                                  //   selectedActivity?.uom || "";
                                  // setPoints(updated);

                                  const selectedActivity =
                                    row.workActivities.find(
                                      a =>
                                        a.workActivityName === e.target.value
                                    );

                                  updated[idx].workActivity =
                                    e.target.value;

                                  updated[idx].UOM =
                                    selectedActivity?.uom || "";

                                  setPoints(updated);
                                }}
                              >
                                <option value="">Select Work Activity</option>

                                {(row.workActivities || []).map((a, i) => (
                                  <option
                                    key={i}
                                    value={a.workActivityName}
                                  >
                                    {a.workActivityName}
                                  </option>
                                ))}
                              </select>

                            </td>
                            <td>
                              {/* <select className="form-select"
                          // {...register("UOM")}
                          value={row.UOM}
  readOnly
                          >
                          <option value="">Select UOM</option>

                          {uoms.map((u) => (
                            <option key={u.id} value={u.uomCode}>
                              {u.uomCode} - {u.description}
                            </option>
                          ))}
                        </select> */}

                              <input
                                type="text"
                                style={{ fontWeight: "bold", color: "black" }}
                                className="form-control"
                                value={row.UOM || ""}
                                readOnly
                              />
                            </td>

                            {/* {(row.UOM === "MA-FT" || row.UOM === "MA-MTR") && (
                        <>
                          <td>
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Length"
                              value={row.length}
                              onChange={(e) => updateMeasurement(idx, "length", e.target.value)}
                            />
                          </td>

                          <td>
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Breadth"
                              value={row.breadth}
                              onChange={(e) => updateMeasurement(idx, "breadth", e.target.value)}
                            />
                          </td>

                          <td>
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Depth"
                              value={row.depth}
                              onChange={(e) => updateMeasurement(idx, "depth", e.target.value)}
                            />
                          </td>
                        </>
                      )} */}

                            {showMeasurementFields && (
                              <>
                                {/* <td>
                            <input
                              type="number"
                              className="form-control"
                              value={row.length || ""}
                              disabled={!(row.UOM === "MA-FT" || row.UOM === "MA-MTR")}
                              onChange={(e) =>
                                updateMeasurement(idx, "length", e.target.value)
                              }
                            />
                          </td>

                          <td>
                            <input
                              type="number"
                              className="form-control"
                              value={row.breadth || ""}
                              disabled={!(row.UOM === "MA-FT" || row.UOM === "MA-MTR")}
                              onChange={(e) =>
                                updateMeasurement(idx, "breadth", e.target.value)
                              }
                            />
                          </td>

                          <td>
                            <input
                              type="number"
                              className="form-control"
                              value={row.depth || ""}
                              disabled={!(row.UOM === "MA-FT" || row.UOM === "MA-MTR")}
                              onChange={(e) =>
                                updateMeasurement(idx, "depth", e.target.value)
                              }
                            />
                          </td> */}

                                <td>
                                  <input
                                    type="number"
                                    step="0.001"
                                    className="form-control"
                                    value={row.nos}
                                    onChange={(e) =>
                                      handlePointChange(
                                        idx,
                                        "nos",
                                        e.target.value
                                      )
                                    }
                                  />
                                </td>

                                <td>
                                  <input
                                    type="number"
                                    className="form-control"
                                    value={row.length || ""}
                                    disabled={!showMeasurementFields}
                                    // onChange={(e) =>
                                    //   updateMeasurement(idx, "length", e.target.value)
                                    // }
                                    onChange={(e) =>
                                      handlePointChange(
                                        idx,
                                        "length",
                                        e.target.value
                                      )
                                    }
                                  />
                                </td>

                                <td>
                                  <input
                                    type="number"
                                    className="form-control"
                                    value={row.breadth || ""}
                                    disabled={!showMeasurementFields}
                                    // onChange={(e) =>
                                    //   updateMeasurement(idx, "breadth", e.target.value)
                                    // }
                                    onChange={(e) =>
                                      handlePointChange(
                                        idx,
                                        "breadth",
                                        e.target.value
                                      )
                                    }
                                  />
                                </td>

                                <td>
                                  <input
                                    type="number"
                                    className="form-control"
                                    value={row.depth || ""}
                                    disabled={!showMeasurementFields}
                                    // onChange={(e) =>
                                    //   updateMeasurement(idx, "depth", e.target.value)
                                    // }
                                    onChange={(e) =>
                                      handlePointChange(
                                        idx,
                                        "depth",
                                        e.target.value
                                      )
                                    }
                                  />
                                </td>
                              </>
                            )}

                            {/* <td>
                        <input
                          type="number"
                          className="form-control"
                          value={row.length || ""}
                          disabled={!(row.UOM === "MA-FT" || row.UOM === "MA-MTR")}
                          onChange={(e) =>
                            updateMeasurement(idx, "length", e.target.value)
                          }
                        />
                      </td>

                      <td>
                        <input
                          type="number"
                          className="form-control"
                          value={row.breadth || ""}
                          disabled={!(row.UOM === "MA-FT" || row.UOM === "MA-MTR")}
                          onChange={(e) =>
                            updateMeasurement(idx, "breadth", e.target.value)
                          }
                        />
                      </td>

                      <td>
                        <input
                          type="number"
                          className="form-control"
                          value={row.depth || ""}
                          disabled={!(row.UOM === "MA-FT" || row.UOM === "MA-MTR")}
                          onChange={(e) =>
                            updateMeasurement(idx, "depth", e.target.value)
                          }
                        />
                      </td> */}



                            <td>
                              {/* <input
                          type="number"
                          className="form-control"
                          value={selectedWorkItem?.quantity || ""}
                          readOnly
                        /> */}

                              <input
                                type="number"
                                style={{ fontWeight: "bold", color: "black" }}
                                className="form-control"
                                value={row.quantity || ""}
                                readOnly
                              />
                            </td>

                            <td>
                              {/* <input
                                type="number"
                                className="form-control"
                                // {...register("workQuantity", { valueAsNumber: true })}
                                value={row.workQuantity || ""}
                                onChange={(e) => {
                                  const updated = [...points];
                                  updated[idx].workQuantity = e.target.value;
                                  setPoints(updated);
                                }}/> */}
                              <input
                                type="number"
                                className="form-control"
                                value={row.workQuantity}
                                readOnly={isCivil}
                                onChange={(e) => {

                                  if (!isCivil) {

                                    handlePointChange(
                                      idx,
                                      "workQuantity",
                                      e.target.value
                                    );

                                  }

                                }}
                              />

                            </td>

                            {/* <td>

                              <input
                                type="text"
                                className="form-control"
                                placeholder="Write point"
                                value={row.point}
                                onChange={(e) => updatePoint(idx, e.target.value)}
                              />
                            </td> */}

                            <td>
                              <textarea
                                className="form-control"
                                rows="3"
                                // {...register("remarks")}
                                value={row.remarks}
                                onChange={(e) => {
                                  const updated = [...points];
                                  updated[idx].remarks = e.target.value;
                                  setPoints(updated);
                                }}
                              />
                            </td>
                            <td className="text-center">


                              {points.length > 1 && (
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  onClick={() => deleteRow(idx)}
                                >
                                  -
                                </button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>

                  </div>

                    {/* PREVIOUS REPORTS TABLE */}
                    <div className="mb-3 mt-3">
                      <button
                        type="button"
                        className="btn btn-success btn-sm me-2 float-end"
                        onClick={addRow}
                      >
                        +
                      </button>
                      <label className="form-label">Previous Reports</label>

                      {prevReports.length === 0 ? (
                        <p className="text-muted">No previous reports found for this project.</p>
                      ) : (
                        <div style={{
                          maxHeight: "300px",   // you can increase to 300 or 400 if needed
                          overflowY: "auto",
                          border: "1px solid #dee2e6"
                        }}>
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th style={{ width: "20%" }}>Report Date</th>
                                {/* <th>Description</th> */}
                              </tr>
                            </thead>
                            <tbody>
                              {prevReports.map((rep) => (
                                <tr key={rep.id}>
                                  <td>{new Date(rep.reportDate).toLocaleDateString("en-GB")}</td>
                                  {/* <td style={{ whiteSpace: "pre-line" }}>{rep.description}</td> */}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  </TabPanel>

                  <TabPanel>

                    <div className="table-responsive" style={{ overflowX: 'auto' }}>

                      <table className="table table-bordered table-striped mt-2" style={{ minWidth: '1950px' }}>

                        <thead>

                          <tr>

                            <th style={{ width: '250px', minWidth: '250px' }}>Item</th>

                            <th style={{ width: '420px', minWidth: '420px' }}>Stock Out Voucher</th>




                            <th colSpan={6} className="text-center">Quantity</th>
                            <th>Notes</th>
                            <th>Action</th>

                          </tr>
                          <tr>
                            <th></th>
                            <th></th>

                            <th>Available</th>
                            <th>Used</th>

                            <th>Lost</th>

                            <th>Damaged </th>

                            <th>Returned </th>
                            <th>Balance</th>
                            <th></th>
                            <th></th>
                          </tr>

                        </thead>

                        <tbody>

                          {materials.map((row, idx) => (

                            <tr key={idx}>

                              <td>
                                <select
                                  className="form-select"
                                  value={row.itemId || ""}
                                  onChange={(e) => handleItemChange(idx, e.target.value)}
                                >
                                  <option value="">
                                    Select Item
                                  </option>
                                  {projectItems?.map(item => (
                                    <option
                                      key={item.itemId}
                                      value={item.itemId}
                                    >
                                      {[item.itemCategoryName, item.itemCode, item.itemName].filter(Boolean).join(" - ")}
                                    </option>
                                  ))}
                                </select>
                              </td>

                              <td>

                                <select
                                  className="form-select"
                                  value={row.stockOutVoucherNo || ""}
                                  onChange={(e) => handleVoucherChange(idx, e.target.value)}
                                >

                                  <option value="">
                                    Select Voucher
                                  </option>

                                  {(() => {
                                    const list = [...(row.vouchers || [])];
                                    if (row.stockOutVoucherNo && !list.some(v => v.vocherNo === row.stockOutVoucherNo)) {
                                      list.push({ vocherNo: row.stockOutVoucherNo });
                                    }
                                    return list.map(v => (
                                      <option
                                        key={v.vocherNo}
                                        value={v.vocherNo}
                                      >
                                        {v.vocherNo}
                                      </option>
                                    ));
                                  })()}

                                </select>

                              </td>
                              <td>

                                <input
                                  className="form-control"
                                  value={
                                    row.availableBalance || ""
                                  }
                                  readOnly
                                />

                              </td>


                              <td>

                                <input
                                  type="number"
                                  className="form-control"
                                  value={row.quantityUsed}
                                  onChange={(e) => {

                                    const updated = [...materials];

                                    // updated[idx].quantityUsed = e.target.value;
                                    updated[idx].quantityUsed =
                                      e.target.value;

                                    updated[idx].balance =
                                      calculateBalance(updated[idx]);

                                    setMaterials(updated);



                                  }}
                                />

                              </td>

                              <td>

                                <input
                                  type="number"
                                  className="form-control"
                                  value={row.quantityLost}
                                  onChange={(e) => {

                                    const updated = [...materials];

                                    updated[idx].quantityLost = e.target.value;

                                    updated[idx].balance =
                                      calculateBalance(updated[idx]);

                                    setMaterials(updated);

                                  }}
                                />

                              </td>

                              <td>

                                <input
                                  type="number"
                                  className="form-control"
                                  value={row.quantityDamaged}
                                  onChange={(e) => {

                                    const updated = [...materials];

                                    updated[idx].quantityDamaged = e.target.value;
                                    updated[idx].balance =
                                      calculateBalance(updated[idx]);

                                    setMaterials(updated);

                                  }}
                                />

                              </td>

                              <td>

                                <input
                                  type="number"
                                  className="form-control"
                                  value={row.quantityReturned}
                                  onChange={(e) => {

                                    const updated = [...materials];

                                    updated[idx].quantityReturned = e.target.value;
                                    updated[idx].balance = calculateBalance(updated[idx]);
                                    setMaterials(updated);

                                  }}
                                />

                              </td>

                              <td>

                                <input
                                  className="form-control"
                                  value={row.balance || ""}
                                  readOnly
                                />

                              </td>

                              <td>

                                <textarea
                                  className="form-control"
                                  value={row.notes}
                                  onChange={(e) => {

                                    const updated = [...materials];

                                    updated[idx].notes = e.target.value;

                                    setMaterials(updated);

                                  }}
                                />

                              </td>

                              <td>

                                {materials.length > 1 && (

                                  <button
                                    type="button"
                                    className="btn btn-danger btn-sm"
                                    onClick={() => deleteMaterialRow(idx)}
                                  >

                                    -

                                  </button>

                                )}

                              </td>

                            </tr>

                          ))}

                        </tbody>

                      </table>

                    </div>

                    <div className="text-end">

                      <button
                        type="button"
                        className="btn btn-success btn-sm"
                        onClick={addMaterialRow}
                      >

                        +

                      </button>

                    </div>

                  </TabPanel>

                  <TabPanel>

                    <div className="table-responsive">

                      <table className="table table-bordered table-striped mt-2">

                        <thead>

                          <tr>
                            <th>Vendor</th>
                            <th>Skilled Labour</th>
                            <th>Unskilled Labour</th>
                            <th>Total</th>
                            <th>Notes</th>
                            <th>Action</th>
                          </tr>

                        </thead>

                        <tbody>

                          {labours.map((row, idx) => (

                            <tr key={idx}>

                              <td>

                                <select
                                  className="form-select"
                                  value={row.vendorId}
                                  onChange={(e) => {

                                    const updated = [...labours];

                                    updated[idx].vendorId = e.target.value;

                                    setLabours(updated);

                                  }}
                                >

                                  <option value="">Select Vendor</option>

                                  {vendors.map(v => {
                                    const contactName = [v.firstName, v.lastName].filter(Boolean).join(" ").trim();
                                    const displayName = contactName ? `${v.vendorName} - ${contactName}` : (v.vendorName || "");
                                    return (
                                      <option key={v.id} value={v.id}>
                                        {displayName}
                                      </option>
                                    );
                                  })}

                                </select>

                              </td>

                              <td>

                                {/* <input
                                  type="number"
                                  className="form-control"
                                  value={row.skilledLabour}
                                  onChange={(e) => {

                                    const updated = [...labours];

                                    updated[idx].skilledLabour = e.target.value;

                                    setLabours(updated);

                                  }}
                                /> */}

                                <input
                                  type="number"
                                  min="0"
                                  step="1"
                                  className="form-control"
                                  value={row.skilledLabour}
                                  onChange={(e) => {
                                    const updated = [...labours];
                                    updated[idx].skilledLabour = parseInt(e.target.value || 0, 10);
                                    setLabours(updated);
                                  }}
                                />

                              </td>

                              <td>

                                {/* <input
                                  type="number"
                                  className="form-control"
                                  value={row.unSkilledLabour}
                                  onChange={(e) => {

                                    const updated = [...labours];

                                    updated[idx].unSkilledLabour = e.target.value;

                                    setLabours(updated);

                                  }}
                                /> */}

                                <input
                                  type="number"
                                  min="0"
                                  step="1"
                                  className="form-control"
                                  value={row.unSkilledLabour}
                                  onChange={(e) => {
                                    const updated = [...labours];
                                    updated[idx].unSkilledLabour = parseInt(e.target.value || 0, 10);
                                    setLabours(updated);
                                  }}
                                />

                              </td>

                              <td>
                                <input
                                  type="number"
                                  className="form-control"
                                  value={
                                    Number(row.skilledLabour || 0) +
                                    Number(row.unSkilledLabour || 0)
                                  }
                                  readOnly
                                />
                              </td>

                              <td>

                                <textarea
                                  className="form-control"
                                  value={row.notes}
                                  onChange={(e) => {

                                    const updated = [...labours];

                                    updated[idx].notes = e.target.value;

                                    setLabours(updated);

                                  }}
                                />

                              </td>

                              <td>

                                {labours.length > 1 && (

                                  <button
                                    type="button"
                                    className="btn btn-danger btn-sm"
                                    onClick={() => deleteLabourRow(idx)}
                                  >

                                    -

                                  </button>

                                )}

                              </td>

                            </tr>

                          ))}

                        </tbody>

                      </table>

                    </div>

                    <div className="text-end">

                      <button
                        type="button"
                        className="btn btn-success btn-sm"
                        onClick={addLabourRow}
                      >

                        +

                      </button>

                    </div>

                  </TabPanel>
                </Tabs>
              </>
            )}

            <hr />


            <div className="mt-3">
              {/* <button className="btn btn-primary me-2" disabled={loading}>
                {loading ? "Saving..." : editMode ? "Update" : "Save"}
              </button> */}

              {reportStatus !== "APPROVED" && (

                <button
                  className="btn btn-primary me-2"
                  disabled={loading}
                >
                  {loading
                    ? "Saving..."
                    : editMode
                      ? "Update"
                      : "Save"}
                </button>

              )}

              {/* <button
                type="button"
                className="btn btn-secondary"
                onClick={() => navigate("/cpnl/dailyreport/view")}
              >
                Cancel
              </button> */}

              <button
                type="button"
                className="btn btn-secondary ms-2"
                onClick={handleCancel}
              >
                Cancel
              </button>
            </div>
          </form>
        )
        }
      </div >
    </>
  );
}
